const configs = {
    //客服链接
    serviceURL: process.env.VUE_APP_SERVICE_URL,

    //图片请求头
    // imgbaseURL: window.location.protocol + "//" + window.location.host,
    imgbaseURL: "https://kjapi.kjcsgo.com",

    // 当前域名
    indexBaseURL: process.env.VUE_APP_INDEX_BASE_URL,

    // 接口地址
    serveBaseURL: process.env.VUE_APP_SERVE_BASE_URL,

    // 接口地址
    chatRoomServeBaseURL: process.env.VUE_APP_CHAT_ROOM_SERVE_BASE_URL,

    // 环境
    ENV: process.env.VUE_APP_ENV,

    // 单点登录地址
    autoLoginURL: process.env.VUE_APP_AUTO_LOGIN_URL,
};

window["configs"] = configs;

export { configs };